(function() {
    'use strict';

    angular
        .module('app')
        .controller('UploadAvatarController', UploadAvatarController);

    UploadAvatarController.$inject = ['$http', '$scope', '$rootScope'];

    function UploadAvatarController($http, $scope, $rootScope){
        var vm = this;
        vm.uploadImage = uploadImage;
        vm.deleteImage = deleteImage;
        vm.cancel = cancel;
        vm.getUrl = getUrl;
        vm.isState = isState;
        vm.changePhoto = changePhoto;
        vm.uploadClick = uploadClick;

        vm.myImage='';
        vm.myCroppedImage='';
        vm.myCroppedImageArray=[];

        vm.states = {
            noImage:'noImage',
            previousImage:'previousImage',
            cropping:'cropping',
            saved:'saved',
            changePhoto:'changePhoto',
        };
        vm.state = vm.states.noImage;

        function uploadClick() {
            if(document.querySelector('#fileInput-'+vm.imageNumber+'-2').files.length > 0) {
                document.querySelector('#fileInput-'+vm.imageNumber+'-2').value = null;
            }
        }

        init();
        function init(){
            vm.decached = Math.random();
            vm.size = vm.size === undefined ? 'md' : vm.size;

            setTimeout(function(){
                imageExists();
                vm.imageSizes = vm.options && vm.options.square ? [{w:1920,h:1920},{w:640,h:640},{w:240,h:240}] : [{w:1920,h:1280},{w:640,h:426},{w:240,h:160}];
                vm.aspectRatio = vm.options && vm.options.square ? 1 : 1.5;
                vm.areaType = vm.options && vm.options.square ? 'circle' : 'rectangle';
                angular.element(document.querySelector('#fileInput-'+vm.imageNumber+'-1')).on('change',handleFileSelect);
                angular.element(document.querySelector('#fileInput-'+vm.imageNumber+'-2')).on('change',handleFileSelect);
            }, 200)
        }

        function isState(state) {
            return vm.state === state;
        }

        function changePhoto() {
            if(!(vm.isState(vm.states.cropping) || vm.isState(vm.states.noImage) || vm.isState(vm.states.changePhoto))) {
                vm.state = vm.states.changePhoto;
            }
        }

        function handleFileSelect(evt) {
          var file=evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function($scope){
                vm.myImage=evt.target.result;
                vm.state = vm.states.cropping;
            });
          };
          reader.readAsDataURL(file);
        };

        function uploadImage(){
            vm.upload_loading = true;
            var formdata = new FormData();
            formdata.append('image_data_xl', vm.myCroppedImageArray[0].dataURI);
            formdata.append('image_data_md', vm.myCroppedImageArray[1].dataURI);
            formdata.append('image_data_xs', vm.myCroppedImageArray[2].dataURI);

            var query = '';
            if(vm.tempSlug){
                query = '?temp_slug='+vm.tempSlug;
            }

            $http.post('api/upload/'+vm.type+'/'+vm.imageNumber+'/'+vm.slug+'/'+query, formdata, {headers: {'Content-Type': undefined}})
            .then(function(response){
                vm.upload_loading = false;
                if(response.data == 'Success'){
                    vm.decached = Math.random();
                    emitAvatarUpdated();
                    imageExists();
                } else if(response.data == 'File too large'){
                    alert('File upload failed: File too large');
                } else if(response.data && response.data.temp_slug){
                    vm.tempSlug = response.data.temp_slug;
                    vm.decached = Math.random();
                    emitUploadedTempImage();
                    emitAvatarUpdated();
                    imageExists();
                }
            })
            .catch(function(){
                alert('File upload failed');
            });
        }

        function deleteImage(){
            var query = '';
            if(vm.tempSlug){
                query = '?temp_slug='+vm.tempSlug;
            }

            $http.delete('api/upload/'+vm.type+'/'+vm.imageNumber+'/'+vm.slug+'/'+query, {headers: {'Content-Type': undefined}})
            .then(function(response){
                vm.state = vm.states.noImage;
                vm.image_exists = false;
            })
            .catch(function(){
                alert('File delete failed');
            });
        }

        function cancel() {
            vm.state = vm.image_exists ? vm.states.previousImage : vm.states.noImage;
            event.stopPropagation();
        }

        function getUrl(){
            var url = '';
            if(vm.tempSlug){
                url = '/uploads/temp_uploads/'+vm.tempSlug+'/'+vm.imageNumber+'_'+vm.size+'.jpeg?decache='+vm.decached;
            } else {
                url = '/uploads/'+vm.type+'/'+vm.slug+'/'+vm.imageNumber+'_'+vm.size+'.jpeg?decache='+vm.decached;
            }
            return url;
        }

        function imageExists(init){
            return $http.get(getUrl())
                .then(function(response){
                    var headers = response.headers();

                    if(headers['image-fallback'] == 'true' || headers['content-length'] == 0){
                        vm.image_exists = false;
                        vm.state = vm.states.noImage;
                    } else {
                        vm.image_exists = true;
                        vm.state = init ? vm.states.previousImage : vm.states.saved;
                    }
                    emitImageExists();
                    return vm.image_exists;
                }).catch(function(response){
                    if(response.status === 404){
                        // the image response status is 404
                        vm.image_exists = false;
                        vm.state = vm.states.noImage;
                        emitImageExists();
                        return vm.image_exists;
                    }
                });
        }

        function emitAvatarUpdated() {
            $rootScope.$emit('update_avatar');
        }

        function emitImageExists(){
            $scope.$emit('uploaded_image_exists', {
                image_exists: vm.image_exists,
                slug: vm.slug,
                image_number: vm.imageNumber,
                type: vm.type
            });
        }

        function emitUploadedTempImage(){
            $scope.$emit('uploaded_image_temp', {
                image_exists: vm.image_exists,
                temp_slug: vm.tempSlug
            });
        }
    }
})();
